import { 
    fetchUserDetailsByUserId, 
    fetchBackofficeUsers, 
    editUser, 
    searchUserGSCIByNIF, 
    fetchGnsList, 
    downloadUsersReport, 
    inactivateUserByUserId, 
    getEntityGroupsDropdown,
    getInstances,
} from "../../api/backoffice";
import {
    getInstalationsDropdown,
    registerNewUser
} from "../../api/authentication";
import Vue from "vue";
import i18n from "@/i18n";
import { bus } from '@/utils/event-bus';
import { downloadFile } from "@/utils/documents";

import store from "@/store";

const hasInvalidValue = (v) => {
    return v.value == null || v.value === "";
};

const ldapMask = "Sistema Autenticação GSC";

function testIfItIsNotEmail(clientEmail) {
    if(!clientEmail || clientEmail.length > 200) {
        return false; 
    }

    // NOSONAR return !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+([_-]\w+)*$/.test(clientEmail);
    return !/^[\w.-]+@[\w.-]+\.\w{2,}$/.test(clientEmail);
}

const getDefaultState = () => {
    return {
        // ******* Backoffice user details *************
        userBkoForm: {},
        userDetails: {},
        userDetailsDropdown: {
            gnsList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            nationalityList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "PT",
            }, {
                value: 2,
                text: "ES",
            }],
            profilesList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 1,
                    text: i18n.t("navbar.profilesLabels.admin"),
                },
                {
                    value: 2,
                    text: i18n.t("navbar.profilesLabels.coordinator"),
                },
                {
                    value: 4,
                    text: i18n.t("navbar.profilesLabels.business_manager"),
                },
                {
                    value: 5,
                    text: i18n.t("navbar.profilesLabels.seller"),
                },
                {
                    value: 6,
                    text: i18n.t("navbar.profilesLabels.financial"),
                },
                {
                    value: 8,
                    text: i18n.t("navbar.profilesLabels.seller_boss")
                },
                {
                    value: 9,
                    text: i18n.t("navbar.profilesLabels.superAdmin"),
                }
            ],
            entitiesList: [
            ],
            entityGroupList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            instanceList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                }
            ],
        },
        containsChanges: false,
        // ******* Backoffice users list *************
        backofficeUsers: [],
        totalPages: 0,
        totalResults: 0,
        filters: {
            idEntity: "",
            profile: "",
            nationality: "",
            status: "S",
            filter_search: "",
        },
        dropdownsFilters: {
            entities: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
            ],
            statusList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "Ativo",
                selected: true,
            }, {
                value: 0,
                text: "Inativo",
            }],
            nationalityList: [{
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            }, {
                value: 1,
                text: "PT",
            }, {
                value: 2,
                text: "ES",
            }],
            profilesList: [
                {
                    value: -1,
                    text: i18n.t("dropdownSelection"),
                    disabled: true,
                },
                {
                    value: 1,
                    text: i18n.t("navbar.profilesLabels.admin"),
                },
                {
                    value: 2,
                    text: i18n.t("navbar.profilesLabels.coordinator"),
                },
                {
                    value: 4,
                    text: i18n.t("navbar.profilesLabels.business_manager"),
                },
                {
                    value: 5,
                    text: i18n.t("navbar.profilesLabels.seller"),
                },
                {
                    value: 6,
                    text: i18n.t("navbar.profilesLabels.financial"),
                },
                {
                    value: 8,
                    text: i18n.t("navbar.profilesLabels.seller_boss")
                },
                {
                    value: 9,
                    text: i18n.t("navbar.profilesLabels.superAdmin"),
                }
            ]
        },
        isTableLoading: false,
    };
};

const state = getDefaultState();

const getters = {
    // ******* Backoffice user details *************
    getUserBkoForm: (state) => state.userBkoForm,
    getUserDetails: (state) => state.userDetails,
    getNationalityList: (state) => state.userDetailsDropdown.nationalityList,
    getProfilesList: (state) => state.userDetailsDropdown.profilesList,
    getEntitiesList: (state) => state.userDetailsDropdown.entitiesList,
    getGnsList: (state) => state.userDetailsDropdown.gnsList,
    getContainsChanges: (state) => state.containsChanges,
    // ******* Backoffice users list *************
    getBackofficeUsers: (state) => state.backofficeUsers,
    getUsersTotalPages: (state) => state.totalPages,
    getUsersTotalResults: (state) => state.totalResults,
    getUsersFilledFilters: (state) =>
        Object.fromEntries(
            Object.entries(state.filters).filter(([, v]) => {
                return v != "";
            })
        ),
    getUsersFilterByKey: (state) => (key) => state.filters[key],
    getDropdown: (state) => (key) => state.dropdownsFilters[key],
    isTableLoading: (state) => state.isTableLoading,
    getEntityGroupList: (state) => state.userDetailsDropdown.entityGroupList,
    getInstanceList: (state) => state.userDetailsDropdown.instanceList,
};

const mutations = {
    // ******* Backoffice user details *************
    setUserBkoForm(state, userBkoForm) {
        state.userBkoForm = userBkoForm;
    },
    setUserDetails(state, userDetails) {
        state.userDetails = userDetails;
    },
    setIsChildren(state, isChildren) {
        state.userDetails.isChildren = isChildren;
    },
    setEntitiesList(state, entitiesList) {
        state.userDetails.entitiesList = entitiesList;
    },
    setEntityGroupList(state, entityGroupList) {
        state.userDetails.entityGroupList = entityGroupList;
    },
    setInstancesList(state, instancesList) {
        state.userDetails.instancesList = instancesList;
    },
    setGnName(state, gnName) {
        state.userDetails.gnName = gnName;
    },
    resetUserDetailsDropdownsState(state) {
        state.userDetailsDropdown = getDefaultState().userDetailsDropdown;
    },
    setEntitySimpleList(
        state,
        {
            data,
            stateType,
            type
        }
    ) {
        state[stateType][type] = data;
    },
    setGNsListDropdown(state,
        {
            data,
            stateType,
            type,
        }) {
        var dropdownNeoObj = data.map((item) => {
            return {
                value: item["ID"],
                text: item["NAME"],
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];
        state[stateType][type] = dropdownNeoObj;
    },
    setFieldValue(state, { key, value, options, onChangeActions }) {
        console.log(options);

        if (key === 'NIF') {
            this.commit("UserBkoFormModule/setEditableField", { key: "searchByNIF", editable: true });
        }

        state?.userBkoForm?.form?.forEach((form) => {
            const field = form.fields.find((f) => f.key === key);
            let fieldGN = form.fields.find((f) => f.key === "gnName");
            
            if (key === 'ID_PROFILE' && fieldGN) {
                fieldGN.editable = false;

                if (value?.value == 5) {
                    fieldGN.editable = true;

                    if (fieldGN?.options?.length > 1) {
                        if (fieldGN?.options?.length === 2) {
                            fieldGN.options[1].selected = true;
                            fieldGN.value = fieldGN.options[1].text;
                        }

                        this.commit("UserBkoFormModule/setIncrementField", { key: fieldGN?.key });
                    }
                }
            }

            if (onChangeActions) {
                onChangeActions.map(async (changeAction) => {

                    if (changeAction.type === "fetchGSCIUserByNIF" && form?.key === "generalData") {
                        const nif = form.fields.find((f) => f.key === "NIF");
                        bus.$emit('fetchGSCIUserByNIF', nif?.value);
                    }

                    if (changeAction.type === "changePhonePrefix" && form?.key === "generalData") {
                        const nationality = field;
                        const phoneNumber = form?.fields?.find((f) => f?.key === "PHONE");

                        nationality.value = value?.text;
                        phoneNumber.prefixValue = nationality?.value === "PT" ? "+351" : "+34";
                    }

                    if (changeAction.type === "closeSearchByNIF" && form?.key === "generalData") {
                        bus.$emit('closeSearchByNIF');
                    }

                    if (changeAction.type === "changeEntities" && form?.key === "accessControl") {
                        const instances = value || [];
                        field.value = instances;
 
                        const idInstances = instances?.map(instance => instance.ID);
                       
                        const entityOptions = this.getters["UserBkoFormModule/getEntitiesList"];

                        const accessControlForm = state?.userBkoForm?.form?.find((form) => form?.key === "accessControl");
                        const entitiesListField = accessControlForm?.fields?.find((f) => f?.key === "entitiesList");
                        
                        const valOptions = entityOptions?.filter((item) => {
                            return idInstances.includes(item?.ID_INSTANCE);
                        });
                        
                        this.commit("UserBkoFormModule/setFieldAttribute", {
                            key: entitiesListField?.key,
                            attribute: 'options',
                            value: valOptions
                        });
                        this.commit("UserBkoFormModule/setIncrementField", { key: entitiesListField?.key });
                    }
                });
            } else {
                if (field) {
                    field.value = value;

                    if (field.type === "dropdown") {
                        field.value = value?.text;
                    }

                    field.hasError = false;
                }
            }
        });
    },
    setFieldAttribute(state, { key, attribute, value }) {
        state?.userBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            
            if (field) {
                if(field.key?.startsWith("entitiesList") || field.key?.startsWith("entityGroupList")) {
                    field[attribute] = value;
                }
            }
        });
    },
    setFieldEditablePWD(state, { editable }) {
        state?.userBkoForm?.form?.map((form) => {
            if (form?.key === "generalData") {
                const field = form.fields.find((f) => f?.key === "PWD");
                field.editable = editable;
            }
        });
    },
    setIncrementField(state, { key }) {
        state?.userBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.keyReRender += 1;
            }
        });
    },
    setToggleUserGSCIDetails(state) {
        const generalDataSection = state?.userBkoForm?.form?.find((form) => form?.key === "generalData");
        const searchByNIF = generalDataSection?.fields?.find((f) => f.key === "searchByNIF");
        const closeSearchByNIF = generalDataSection?.fields?.find((f) => f.key === "closeSearchByNIF");

        searchByNIF.fieldShow = !searchByNIF.fieldShow;
        closeSearchByNIF.fieldShow = !closeSearchByNIF.fieldShow;
    },
    setContainsChanges(state, containsChanges) {
        state.containsChanges = containsChanges;
    },
    setEditableField(state, { key, editable }) {
        state?.userBkoForm?.form?.forEach((form) => {
            const field = form?.fields?.find((f) => f.key === key);
            if (field) {
                field.editable = editable;
            }
        });
    },
    // ******* Backoffice users list *************
    setBackofficeUsers(state, backofficeUsers) {
        backofficeUsers = backofficeUsers?.map((user) => {
            return {
                ...user?.user,
                children: user?.children
            }
        })
        state.backofficeUsers = backofficeUsers;
    },
    setUsersTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setUsersTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setUsersFilters(state, usersFilters) {
        state.usersFilters = usersFilters;
    },
    setMixedDropdownValues(
        state,
        {
            data,
            stateType = "dropdownsFilters",
            type,
            valueKey = "ID",
        }
    ) {
        var dropdownNeoObj = data.map((item) => {
            return {
                value: item?.[valueKey],
                text: item?.NAME,
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state[stateType][type] = dropdownNeoObj;
    },
    setFilterByKey(state, filter) {
        state.filters[filter.key] = filter.value;
    },
    setFilters(state, filters) {
        state.filters = filters;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
    setEntityGroupSimpleList(state, { data, stateType, type }) {
        state[stateType][type] = data;
    },
    setInstanceSimpleList(state, { data, stateType, type }) {
        const newData = data?.map((item) => {
            return { 
                ...item,
               disabled: item?.STATUS === 'N'
            };
        })
        state[stateType][type] = newData;
    }
};

const actions = {
    // ******* Backoffice user details *************
    async getUserDetails({ commit }, userId) {
        try {
            const response = await fetchUserDetailsByUserId(userId);
            const userDetails = response?.data?.data?.data; 
            userDetails.instances = userDetails?.instances?.map((item) => {
                return { 
                    ID: item["id"], 
                    NAME: item["nameEx"],
                };
            });
  
            commit("setUserDetails", userDetails);
            if (response?.data?.data?.isChildren) commit("setIsChildren", response?.data?.data?.isChildren);
            if (response?.data?.data?.gnName) commit("setGnName", response?.data?.data?.gnName);
            
            commit("setEntitiesList", response?.data?.data?.userEntitiesList);

            //const instancesList = response?.data?.data?.data?.instances || [];
            //commit("setInstancesList", instancesList);
            return response?.data?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async getEntitiesList({ commit }) {
        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getInstalationsDropdown(idInstance);
            const entities = response?.data?.data;
            commit("setEntitySimpleList", {
                data: entities,
                stateType: "userDetailsDropdown",
                type: "entitiesList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getGnsList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchGnsList(idInstance);
            const gns = response?.data?.data;
            commit("setGNsListDropdown", {
                data: gns,
                stateType: "userDetailsDropdown",
                type: "gnsList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async checkIfFormIsValid({ commit }) {
        Vue.$toast.clear();
        commit("setTableLoading", false);
        const fieldsWithError = [];
        let outOfContextErrors = [];

        state.userBkoForm.form.map((sections) => sections?.fields.map((field) => {
            // se o field estiver activo e for required, validar valor
            // se o field tiver visivel
            if (!field.disabled && !field.hidden && field.required && field.editable && field.fieldShow) {
                const validation = hasInvalidValue(field);
                field.hasError = validation;
                if (validation) fieldsWithError.push(field.label);
            }

            if (field?.key === 'instances') {
                const instanceListValue = field.value;
                delete instanceListValue["__ob__"]; 
                let errorMessage = "";
                if (instanceListValue.length <= 0) {
                    errorMessage = i18n.t("form.error.entityGroupWithAccessValidation");
                    outOfContextErrors.push(errorMessage);
                    field.hasError = true;
                }
            }

            if (field?.key === 'EMAIL') {
                const emailValue = field.value;
                let errorMessage = "";
                if (emailValue) {
                    let isNotValid = testIfItIsNotEmail(emailValue);
                    if (isNotValid) {
                        errorMessage = i18n.t("form.error.emailFormat");
                        outOfContextErrors.push(errorMessage);
                        field.hasError = true;
                    }
                }
            }
            outOfContextErrors = Array.from(new Set(outOfContextErrors));
        }));

        let errorMessage = "<ul>";

        if (fieldsWithError.length || outOfContextErrors.length) {

            fieldsWithError.forEach((label) => {
                if(label === 'Search') {
                    errorMessage += `<li>${i18n.t("form.error.searchByNif")}`;
                } else {
                    errorMessage += `<li>${i18n.t("form.error.requiredFieldWithNoValue", { field: i18n.t(label) })}</li>`;
                }
            });

            outOfContextErrors.forEach((label) => {
                errorMessage += `<li>${i18n.t(label)}</li>`;
            });

            errorMessage += "</ul>";

            Vue.$toast.open({
                message: errorMessage,
                dismissible: true,
                type: "error",
            });

            return false;
        } else {
            return true;
        }
    },
    async registerNewUser({ commit }, payload) {
        commit("setTableLoading", false);
        try {
            const response = await registerNewUser(payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async searchUserGSCIByNIF({ commit }, nif) {
        commit("setTableLoading", false);
        try {
            const response = await searchUserGSCIByNIF(nif);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    fillUserWithUserGSCIDetails({ commit }, { userDetails, onEdit }) {
        if(!onEdit) {
            commit("setFieldValue", { "key": "NAME", "value": userDetails?.NAME });
            commit("setFieldValue", { "key": "LOGIN", "value": userDetails?.LOGIN });
            commit("setFieldValue", { "key": "GENDER", "value": userDetails?.GENDER === "M" ? 1 : 2 });
            commit("setIncrementField", { key: "GENDER" });
            commit("setFieldValue", { "key": "PWD", "value": userDetails?.PWD === "LDAP" ? ldapMask : userDetails?.PWD });
            commit("setEditableField", { key: "PWD", editable: userDetails?.PWD ? false : true });
            commit("setFieldValue", { "key": "EMAIL", "value": userDetails?.EMAIL });
            commit("setFieldValue", { "key": "PHONE", "value": userDetails?.PHONE});
        } else {
            commit("setFieldValue", { "key": "LOGIN", "value": userDetails?.LOGIN });
            commit("setFieldValue", { "key": "EMAIL", "value": userDetails?.EMAIL });
            commit("setFieldValue", { "key": "PWD", "value": userDetails?.PWD === "LDAP" ? ldapMask : userDetails?.PWD });
            commit("setEditableField", { key: "PWD", editable: userDetails?.PWD ? false : true });
        }
        commit("setToggleUserGSCIDetails");
    },
    fillUserEditableField({ commit }, idEditable) {
        commit("setEditableField", { key: "NAME", editable: idEditable });
        commit("setEditableField", { key: "LOGIN", editable: idEditable });
        commit("setEditableField", { key: "EMAIL", editable: idEditable });
        commit("setEditableField", { key: "PHONE", editable: idEditable });
        commit("setEditableField", { key: "PWD", editable: idEditable});

        commit("setEditableField", { key: "searchByNIF", editable: !idEditable});
    },
    clearUserGSCI({ commit }, userDetails) {
        commit("setFieldValue", { "key": "NAME", "value": userDetails?.NAME || "" });
        commit("setFieldValue", { "key": "LOGIN", "value": userDetails?.LOGIN || "" });
        commit("setFieldValue", { "key": "GENDER", "value": 1 });
        commit("setIncrementField", { key: "GENDER" });
        commit("setFieldValue", { "key": "PWD", "value": userDetails?.PWD === "LDAP" ? ldapMask : userDetails?.PWD || "" });
        commit("setEditableField", { key: "PWD", editable: userDetails?.PWD ? false : true });
        commit("setFieldValue", { "key": "EMAIL", "value": userDetails?.EMAIL || "" });
        commit("setFieldValue", { "key": "PHONE", "value": userDetails?.PHONE || "" });

        commit("setToggleUserGSCIDetails");
    },
    // ******* Backoffice users list *************
    async getBackofficeUsers({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            console.log('idInstance: ', idInstance)
            const response = await fetchBackofficeUsers(
                page.page,
                page.orderBy,
                page?.search,
                page?.pageSize,
                idInstance
            );
            commit("setBackofficeUsers", response?.data?.data);
            commit("setUsersTotalPages", response?.data?.pages);
            commit("setUsersTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async fetchInstalationsDropdown({ commit }) {
        try {
            const idInstance = store.getters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getInstalationsDropdown(idInstance);
            const entities = response?.data?.data;
            commit("setMixedDropdownValues", {
                data: entities,
                type: "entities",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async deleteUser({ commit }, userId) {
        commit("setTableLoading", false);
        try {
            const response = await inactivateUserByUserId(userId);
            return response?.data?.data;
        } catch (error) {
            console.log(error)
        }
    },
    async editUser({ commit }, { userId, payload }) {
        commit("setTableLoading", false);
        try {
            const response = await editUser(userId, payload);
            return response;
        } catch (error) {
            console.log(error)
        }
    },
    async downloadUserReport({ commit, rootGetters }, page) {
        commit("setTableLoading", false);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await downloadUsersReport(page?.search, idInstance);
            const currentTimeInMillis = Date.now();

            downloadFile(response.data, "SIFA_Utilizadores_" + currentTimeInMillis);
        } catch (error) {
            console.log(error)
        }
    },
    async getEntityGroupList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await getEntityGroupsDropdown(idInstance);
            const entityGroups = response?.data?.data;

            commit("setEntityGroupSimpleList", {
                data: entityGroups,
                stateType: "userDetailsDropdown",
                type: "entityGroupList",
            });
        } catch (error) {
            console.log(error)
        }
    },
    async getInstanceList({ commit }) {
        try {
            const response = await getInstances();
            const instances = response?.data?.data || [];

            commit("setInstanceSimpleList", {
                data: instances,
                stateType: "userDetailsDropdown",
                type: "instanceList",
            });
        } catch (error) {
            console.log(error)
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
